import React, {createContext, useContext, useRef, useState} from 'react';
import AccountStatusModal from '../components/modules/AccountStatusModal';
import {getUserProfileData} from '../utils/GeneralStorage';
import {DLog} from '../utils/HelperMethods';
import {ACCOUNT_STATUS, HTTP_METHODS} from '../utils/URLConstants';
import {fetchApi} from '../utils/ApiHelper';
import {shopContext} from './ShopContext';

export const accountStatusContext = createContext();
const {Provider} = accountStatusContext;

const AccountStatusContext = props => {
  const [visible, setVisible] = useState(false);
  const [showCoaches, setShowCoaches] = useState(true);
  const [isOnboarded, setOnboarded] = useState(false);
  const navigationRef = useRef();
  const ShopC = useContext(shopContext);

  useState(() => {
    (async () => {
      const profile = await getUserProfileData();
      // DLog(profile);
      if (profile && profile.coachingOnboarded) {
        setOnboarded(true);
      }
    })();
  }, []);

  const setNavigationRef = navigation => {
    navigationRef.current = navigation;
  };

  const getUserAccountStatus = (setShowLoader = () => {}) => {
    fetchApi(HTTP_METHODS.GET, ACCOUNT_STATUS)
      .then(response => {
        setShowLoader(false);
        if (response.status == 200) {
          const responseData = response.data.data;
          //Checking for sfId in response and setting the appropriate behaviour
          ShopC.setCanUserCheckout(responseData.sfId != null);
          // Removed isActive check - all users are now active by default
          // if (!responseData.isActive) {
          //   setVisible(true);
          //   setNavigationRef(navigationRef.current);
          // }
          if (responseData.plan) {
            if (responseData.plan.appFeatures.length > 0) {
              let hasCoachList = false;
              responseData.plan.appFeatures.map((item, index) => {
                if (item.id === '3') {
                  hasCoachList = true;
                }
              });
              setShowCoaches(hasCoachList);
            } else {
              setShowCoaches(false);
            }
          } else {
            setShowCoaches(false);
          }
        }
      })
      .catch(error => {
        setShowLoader(false);
      });
  };

  return (
    <>
      <Provider
        value={{
          visible,
          setVisible,
          showCoaches,
          setShowCoaches,
          isOnboarded,
          setOnboarded,
          setNavigationRef,
          getUserAccountStatus,
        }}>
        {props.children}
      </Provider>
      <AccountStatusModal
        visible={visible}
        navigation={navigationRef.current}
        setVisible={setVisible}
      />
    </>
  );
};

export default AccountStatusContext;
